import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import {
  isLoading,
  LOADING,
} from "@coworker/apprestructured/src/task-management/loading";
import { ViewerTopFragmentCommonProps } from "../viewer-top-fragment/ViewerTopFragment";
import MultipleArticles from "../../../MultipleArticles/MultipleArticles";
import { ItemNoAndType } from "@coworker/apprestructured/src/shared/types/item";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import { useAllAttachedItems } from "@coworker/apprestructured/src/task-management/services/useAllAttachedItems";

export type MultipleArticlesViewerTopFragmentConfigProps = {
  field: string;
};

type MultipleArticlesViewerTopFragmentProps = {
  configProps: MultipleArticlesViewerTopFragmentConfigProps;
  commonProps: ViewerTopFragmentCommonProps;
};

function MultipleArticlesViewerTopFragment({
  configProps,
  commonProps,
}: MultipleArticlesViewerTopFragmentProps) {
  const { field } = configProps;
  const { task } = commonProps;
  const itemNosAndType = getByPath<ItemNoAndType[]>(task, field);
  const state = getByPath<TaskState>(task, "state");

  const { items, isFetchingItems } = useAllAttachedItems(itemNosAndType);

  if (isLoading(itemNosAndType) || itemNosAndType.length === 0) {
    return null;
  }

  return (
    <MultipleArticles
      articles={isFetchingItems ? LOADING : items}
      state={state}
    />
  );
}

export default MultipleArticlesViewerTopFragment;
